<template>
  <FlexRow justify="space-between" align="center" wrap class="mb-2">
    <FlexRow :space="2" wrap align="baseline" class="flex-1">
      <FlexRow space="half">
        <Label :text="`ID:${applicant.id}さん`" />
        <Label v-if="newUser" text="New!" bold color="caution" />
      </FlexRow>

      <FlexRow v-if="applicant.age" :space="0">
        <Label text="年齢：" />
        <Label :text="`${applicant.age}歳`" bold />
      </FlexRow>
  
      <FlexRow v-if="applicant.salary" :space="0">
        <Label text="現年収：" />
        <Label :text="`${applicant.salary}万円`" bold />
      </FlexRow>
      
      <FlexRow :space="0" align="baseline">
        <Label text="転職意欲：" />
        <ChangeJobMotivationLabel :motivation="applicant.changeJobMotivation" />
      </FlexRow>
      <FlexRow v-if="applicant.lastLoggedInAt" :space="0" align="baseline">
        <Label text="最終ログイン：" />
        <LastLoggedInLabel :lastLoggedInAt="applicant.lastLoggedInAt" />
      </FlexRow>
      <Chip v-if="submissionTip" size="small" color="submission" text-color="white" un-clickable>
        <Label :text="submissionTip" />
      </Chip>
      <Chip v-if="gradeTip" size="small" color="grade" text-color="white" un-clickable>
        <Label :text="gradeTip" />
      </Chip>
    </FlexRow>
    <FlexRow :space="0" align="center">
      <ApplicantListAddButton :applicant="applicant" />
      <ApplicantFavoriteAddButton :applicant="applicant" />
      <ApplicantHideButton :applicant="applicant" :hidden="hidden" />
    </FlexRow>
  </FlexRow>
</template>

<script>
import FlexRow from "@/components/atoms/FlexRow";
import Label from "@/components/atoms/Label";
import ApplicantListAddButton from "@/components/molecules/ApplicantListAddButton";
import ApplicantFavoriteAddButton from "@/components/molecules/ApplicantFavoriteAddButton";
import ApplicantHideButton from "@/components/molecules/ApplicantHideButton";
import ComponentMixin from "@/components/ComponentMixin";
import ChangeJobMotivationLabel from "@/components/molecules/ChangeJobMotivationLabel";
import LastLoggedInLabel from "@/components/molecules/LastLoggedInLabel";
import moment from "moment";
import Chip from "../atoms/Chip";
import {mapGetters} from "vuex";

export default {
  mixins: [ComponentMixin],
  name: "ApplicantCardHeader",
  components: { Chip, LastLoggedInLabel, ChangeJobMotivationLabel, ApplicantHideButton, ApplicantFavoriteAddButton, ApplicantListAddButton, Label, FlexRow},
  props: {
    applicant: {
      type: Object
    },
    targetJob: {
      type: Object
    },
    requestorId: {
      type: String
    },
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    newUser() {
      return moment().diff(moment(this.applicant.joinedAt), "days") <= 30
    },
    loggedInAt() {
      return this.fromNow(this.applicant.lastLoggedInAt)
    },
    hidden() {
      const query = this.$route.query
      const list = query.list
      return list === "hidden"
    },
    submissionTip() {
      if (this.applicant.competition && this.applicant.competition.submissionTip) {
        return this.constsToText(this.applicant.competition.submissionTip, this.consts.competitionTip)
      }
      return undefined
    },
    gradeTip() {
      if (this.applicant.competition && this.applicant.competition.gradeTip) {
        return this.constsToText(this.applicant.competition.gradeTip, this.consts.competitionTip)
      }
      return undefined
    }
  }
}
</script>
